<template>

    <form ref="colaborador-form-inativar" v-on:submit.prevent="Inativar(model)" novalidate>
        <div class="row">
            <div class="form-group col-md-12">
                <label for="escolaId">Escola</label>
                <select v-select="{ dataitem: 'Escola', default: 'Todos' }" v-model="model.escolaId" class="form-control" name="escolaId" required></select>
            </div>
            <section class="col-md-12">
                <div class="alert alert-danger">
                    <i class="fa fa-info-circle"></i> Você tem certeza sobre a inativação de todos os colaboradores de uma vez?
                </div>
            </section>
            <div v-if="prosseguir" class="form-group col-md-12">
                <label for="motivo">Motivo</label>
                <textarea v-model="model.motivo" class="form-control" name="motivo" required></textarea>
            </div>
            <div class="col-md-12">
                <br />
                <button v-if="!prosseguir" type="button" class="btn-large-40 btn-red uppercase float-right" @click="Prosseguir()">Sim</button>
                <button v-if="!prosseguir" type="button" class="btn-large-40 btn-default uppercase" @click="onBack()">Não</button>
                <button v-if="prosseguir" type="button" class="btn-large-40 btn-success uppercase float-right" @click="Inativar(model)">Inativar</button>
            </div>
        </div>
    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "colaborador-form-inativar",
        mixins: [base],
        props: { colaboradorId: Number },
        data: () => ({
            model: {

                escolaId: "",
                motivo: ""
            },
            filters: {},
            prosseguir: false,
            form: "colaborador-form-inativar",

            resources: {
                edit: 'colaborador',
            },

        }),

        methods: {
            Prosseguir: function () {
                this.prosseguir = true;
            },

            Inativar: function (model) {
                if (this.formValidate() == false)
                    return;
                new Api('escola/inativatodoscolaboradores').post(model).then(data => {
                    this.defaultSuccessResult("Inativação realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },
            onBack: function () {
                this.$emit('on-back')
            },
        },




    };
</script>
